<template>
  <div class="policy" :style="{ backgroundImage: `url(${require('../assets/images/grafokettbakgrundsbild2.png')})` }">
    <div class="policy-document">
      <vue-markdown v-if="policy !== null">{{ policy.data.policyDocument }}</vue-markdown>
    </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown'
export default {
  name: "Policy",
  data: () => ({
   policy: null
  }),
  components: {
    VueMarkdown
  },
  methods: {
    async getLatestPolicy () {
      const response = await this.$store.$api.get('/api/account/invite/policy')
      this.policy = response.data
    }
  },
  async mounted() {
    await this.getLatestPolicy()
  }
}
</script>

<style lang="postcss">
  .policy {
    min-height: calc(100vh - theme('variables.header-size') * 2);
    @apply relative min-w-full bg-cover bg-center;
  }
  .policy-document {
    max-width: 800px;
    margin: 4em auto;
    line-height: 2;
  }

  .policy-document a {
    @apply text-white;
  }
</style>
